<app-przycisk-mydlo ikona="koperta" class="hidden um-desktop:flex" (click)="pokazKontaktDialog()" label="{{'codes.nawigacja.etykieta-kontakt' | translate}}">
</app-przycisk-mydlo>
<app-przycisk-mydlo ikona="koperta" class="um-desktop:hidden" (click)="pokazKontaktBelkaBoczna()" label="{{'codes.nawigacja.etykieta-kontakt' | translate}}">
</app-przycisk-mydlo>
